<style>
#video {
  height: 84px;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <!-- <div class="group">
      <button
        class="ribbon-button"
        @click="show('legendModal')"
        title="Legenda mapy"
      >
        <span class="icon">
          <v-icon>layers</v-icon>
        </span>
        <span class="caption">WARSTWY</span>
      </button>
    </div> -->
    <div
      class="group"
      v-if="$can('read','videos_registry')"
    >
      <button
        @click="show('videoRegisterModal')"
        class="ribbon-button btn--large"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR INSPEKCJI WIDEO</span>
      </button>
    </div>

    <div class="group">
      <div class="container__group--rows">
        <div
          class="ribbon-button ribbon__row"
          @click="show('addVideoInspectionCardModal')"
        >
          <span class="icon">
            <v-icon style="font-size:16px;">add_circle</v-icon>
          </span>
          <button class="caption">DODAJ INSPEKCJĘ</button>
        </div>

        <div
          class="ribbon-button ribbon__row"
          @click="loadVideoInspections"
          v-if="!ifInspectionsVisible"
        >
          <span class="icon">
            <v-icon style="font-size:16px;">add_circle</v-icon>
          </span>
          <button class="caption">POKAŻ OBIEKTY Z WYKONANĄ INSPEKCJĄ</button>
        </div>
        <div
          class="ribbon-button ribbon__row"
          @click="hideVideoInspections"
          v-else
        >
          <span class="icon">
            <v-icon style="font-size:16px;">remove_circle</v-icon>
          </span>
          <button class="caption">UKRYJ OBIEKTY Z WYKONANA INSPEKCJĄ</button>
        </div>
      </div>
    </div>
    <!-- <div class="group">
      <CommonComp />
    </div> -->
    <div
      class="more-hidden"
      id="showMore"
    >
      <a href="#">
        <span class="fa fa-ellipsis-h"></span>
      </a>
      <ul class="hidden-menu"></ul>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
// import CommonComp from "../../shared/CommonComp";
import vueCustomScrollbar from "vue-custom-scrollbar";
export default {
  components: {
    // CommonComp,
    vueCustomScrollbar
  },
  data: vm => ({
    ifInspectionsVisible: false
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    getVideoCards() {
      return this.$store.getters.getVideoInspectionCards;
    }
  },
  methods: {
    loadVideoInspections() {
      this.ifInspectionsVisible = true;
      let payload = {
        attachments: true,
        pipes: false
      };
      this.$store.dispatch("getVideoInspectionCards", payload).then(r => {
        if(r.data.length > 0) {
          this.$root.$emit("drawVideoInspections", true);
        } else {
          this.$root.$emit(
            "showSnackbar",
            "orange",
            "Brak inspekcji do wyświetlenia"
          );
        }
      })
    },
    hideVideoInspections() {
      this.ifInspectionsVisible = false;
      this.$root.$emit("drawVideoInspections", false);
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/video/Video.vue